// Adapted from ui-component-library/src/utils/clx.ts — same call shape,
// without the `classnames` dependency (ADR 0002).
export type ClassValue = string | number | bigint | boolean | null | undefined | ClassValue[]

/** Join class names, skipping falsy values and flattening arrays. */
export function clx(...values: ClassValue[]): string {
  const out: string[] = []
  for (const value of values) {
    if (!value || value === true) continue
    if (Array.isArray(value)) {
      const nested = clx(...value)
      if (nested) out.push(nested)
    } else {
      out.push(String(value))
    }
  }
  return out.join(' ')
}
